// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"'styles/breakpoints.module.css'","DESKTOP_WIDTH":"993px","subtitle":"styles_subtitle__dM9yN","title":"styles_title__2Eza_","border":"styles_border__JoHjx"};